import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1012782631449952';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Injects the Meta (Facebook) Pixel base code and fires a single PageView.
 * Mount once at the app root.
 *
 * Note: we intentionally avoid the verbatim Facebook snippet's
 * `getElementsByTagName('script')[0].parentNode.insertBefore(...)` pattern,
 * because in a bundled / iframe preview there may be no reachable <script>
 * element, which makes that reference undefined and throws.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // Set up the fbq command queue stub (idempotent).
    if (!window.fbq) {
      const fbq: any = function (...args: unknown[]) {
        fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
    }
    // Load the fbevents.js library once, appending safely to <head>.
    const SRC = 'https://connect.facebook.net/en_US/fbevents.js';
    const alreadyLoaded = Array.from(document.getElementsByTagName('script')).some(el => el.src === SRC);
    if (!alreadyLoaded) {
      const script = document.createElement('script');
      script.async = true;
      script.src = SRC;
      const parent = document.head || document.body || document.documentElement;
      if (parent) parent.appendChild(script);
    }
    // Initialize and fire a single PageView.
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-13">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-14" />
    </noscript>;
}